// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import * as Yup from 'yup';

// change profile password Validation Schema
const resetPasswordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .required('Password is required')
    .test(
      '',
      'Password should contain one lowercase letter, one uppercase letter, one number and one special character',
      value => [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/].every(pattern => pattern.test(value)),
    )
    .min(8, 'Password should be more than 8 characters'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('New Password is required'),
});

export default resetPasswordValidationSchema;
